import { Component } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

/**
 * Standalone component that renders the session expired confirmation dialog.
 * Should be placed in the root app component template of each application
 * that uses TokenWmsInterceptorFn.
 */
@Component({
    selector: 'kanzi-session-expired-dialog',
    imports: [ConfirmDialogModule],
    template: `
    <p-confirmDialog
      key="sessionExpired"
      [closable]="false"
      [dismissableMask]="false"
      [style]="{ width: '400px' }"
      [baseZIndex]="100000"
      acceptButtonStyleClass="p-button-warning"
    ></p-confirmDialog>
  `
})
export class SessionExpiredDialogComponent {}
